import { render, staticRenderFns } from "./UiExportToExcel.vue?vue&type=template&id=6d5d995c"
import script from "./UiExportToExcel.vue?vue&type=script&lang=js"
export * from "./UiExportToExcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports